import { render, staticRenderFns } from "./preAlipayAndRealNameDialog.vue?vue&type=template&id=d1b40b16&scoped=true"
import script from "./preAlipayAndRealNameDialog.vue?vue&type=script&lang=js"
export * from "./preAlipayAndRealNameDialog.vue?vue&type=script&lang=js"
import style0 from "./preAlipayAndRealNameDialog.vue?vue&type=style&index=0&id=d1b40b16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b40b16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1b40b16')) {
      api.createRecord('d1b40b16', component.options)
    } else {
      api.reload('d1b40b16', component.options)
    }
    module.hot.accept("./preAlipayAndRealNameDialog.vue?vue&type=template&id=d1b40b16&scoped=true", function () {
      api.rerender('d1b40b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/returnPickupPrint/components/preAlipayAndRealNameDialog.vue"
export default component.exports